import React from "react";
import {
    Button,
    Flex,
    Skeleton,
    Text,
    List,
    Box,
    Divider,
    NavLink,
} from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faArrowRightFromBracket } from "@fortawesome/pro-light-svg-icons";
import { faIdCard } from "@fortawesome/pro-light-svg-icons";
import useLogout from "../hooks/useLogout.js";
import useMemberWithPlans from "../hooks/useMembersWithPlans.js";
import useAnalytics from "../hooks/useAnalytics.js";
import MenuLink from "./MenuLink.js";

export default function SideMenu() {
    const logout = useLogout();
    const { trackEvent, AnalyticsEvents } = useAnalytics();

    const { data, isLoading } = useMemberWithPlans();

    return (
        <>
            <Flex
                align={"flex-start"}
                direction={"column"}
                gap={"md"}
                p="md"
                sx={{
                    zIndex: 5,
                }}
            >
                <Box
                    display="flex"
                    sx={{ flexDirection: "column" }}
                    w={{ sm: 325 }}
                    h="100%"
                >
                    <Box pb={"md"} pr={"md"}>
                        <Text fz="sm">LOGGED IN AS:</Text>
                        {isLoading && (
                            <>
                                <Skeleton height={24} radius="xl" my={8} />
                                <Skeleton height={18} radius="xl" my={8} />
                                <Skeleton />
                            </>
                        )}
                        {data.map((member) => {
                            return (
                                <React.Fragment
                                    key={member.fullSubscriberNumber}
                                >
                                    <Text fz="xl" fw={"700"}>
                                        {member.firstName} {member.lastName}
                                    </Text>
                                    <Text pb="md" pr="md">
                                        {member.plan.name}
                                    </Text>
                                </React.Fragment>
                            );
                        })}

                        <Divider />
                    </Box>

                    <Box
                        display="flex"
                        sx={{
                            flexDirection: "column",
                            overscrollBehavior: "contain",
                            overflowY: "auto",
                        }}
                    >
                        <MenuLink
                            icon={
                                <FontAwesomeIcon
                                    icon={faIdCard}
                                    fontSize="24"
                                    fixedWidth={true}
                                />
                            }
                            to="/cards"
                            label="ID Card"
                            onClick={() => trackEvent(AnalyticsEvents.MENU_ID_CARD_CLICKED)}
                            //variant="subtle"
                            //variant="filled"
                        />
                        <NavLink
                            icon={
                                <FontAwesomeIcon
                                    icon={faArrowRightFromBracket}
                                    fontSize="24"
                                    fixedWidth={true}
                                />
                            }
                            onClick={() => {
                                trackEvent(AnalyticsEvents.MENU_LOGOUT_CLICKED);
                                logout("/login");
                            }}
                            label="Logout"
                            //variant="subtle"
                            //variant="filled"
                        />
                    </Box>
                </Box>
            </Flex>
        </>
    );
}
